import { __decorate } from "tslib";
import { Component, Watch, Mixins } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import AlertMixin from './AlertMixin';
import GraphqlErrorMixin from './GraphqlErrorMixin';
import ButtonLoaderMixin from './ButtonLoaderMixin';
let FormMixin = class FormMixin extends Mixins(AlertMixin, GraphqlErrorMixin, validationMixin, ButtonLoaderMixin) {
    resetForm() {
        const form = this.$refs.form;
        if (form) {
            form.reset();
        }
        this.resetValidations();
    }
    onToggleFormStateChanged(newValue) {
        if (!newValue) {
            this.resetForm();
        }
    }
    resetValidations() {
        if (this.$v) {
            this.$v.$reset();
        }
    }
};
__decorate([
    Watch('toggleForm')
], FormMixin.prototype, "onToggleFormStateChanged", null);
FormMixin = __decorate([
    Component
], FormMixin);
export default FormMixin;
